import React from 'react';
import './DashboardPages.css';

const Reports = () => {
  const reports = [
    { name: 'Monthly Sales Report', date: '2025-01-15', status: 'Ready' },
    { name: 'Customer Analytics', date: '2025-01-14', status: 'Ready' },
    { name: 'Inventory Report', date: '2025-01-13', status: 'Processing' },
    { name: 'Financial Overview', date: '2025-01-12', status: 'Ready' },
  ];

  return (
    <div className="page-container">
      <h2 className="page-title">Reports</h2>

      <div className="reports-table">
        <table>
          <thead>
            <tr>
              <th>Report Name</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report, index) => (
              <tr key={index}>
                <td>{report.name}</td>
                <td>{report.date}</td>
                <td>
                  <span className={`status ${report.status.toLowerCase()}`}>
                    {report.status}
                  </span>
                </td>
                <td>
                  <button className="action-btn">Download</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Reports;
